export default {
  name: 're-info',
  props: {
    containerClass: {
      type: [String, Array, Object],
      default: null
    },
    title: {
      type: [String],
      default: null
    },
    headerText: {
      type: [String],
      default: null
    },
    imgSrc: {
      type: String,
      default: null
    },
    imgAlt: {
      type: String,
      default: 'image'
    },
    footerText: {
      type: [String],
      default: null
    },
    buttonTitle: {
      type: [String],
      default: 'Ok'
    },
    buttonClass: {
      type: [String, Array, Object],
      default: null
    },

  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
}
